// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { initializeLanguages, isString, overwriteTranslations } from "@sequentech/ui-core";
import englishTranslation from "../translations/en";
import spanishTranslation from "../translations/es";
import catalanTranslation from "../translations/cat";
import frenchTranslation from "../translations/fr";
import tagalogTranslation from "../translations/tl";
import galegoTranslation from "../translations/gl";
import dutchTranslation from "../translations/nl";
import basqueTranslation from "../translations/eu";
import i18next from "i18next";
initializeLanguages({
    en: englishTranslation,
    es: spanishTranslation,
    cat: catalanTranslation,
    fr: frenchTranslation,
    tl: tagalogTranslation,
    gl: galegoTranslation,
    nl: dutchTranslation,
    eu: basqueTranslation,
});
export var triggerOverrideTranslations = function (i18n) {
    initializeLanguages({
        en: englishTranslation,
        es: spanishTranslation,
        cat: catalanTranslation,
        fr: frenchTranslation,
        tl: tagalogTranslation,
        gl: galegoTranslation,
        nl: dutchTranslation,
        eu: basqueTranslation,
    });
    overwriteTranslations({ i18n: i18n }, true);
};
export var getAllLangs = function () { return ["en", "es", "cat", "fr", "tl", "gl", "nl", "eu"]; };
export var addDefaultTranslationsToElement = function (data) {
    var i18n = {};
    var langs = getAllLangs();
    for (var _i = 0, langs_1 = langs; _i < langs_1.length; _i++) {
        var lang = langs_1[_i];
        var i18nLang = {};
        if (isString(data.name)) {
            i18nLang["name"] = data.name;
        }
        if (isString(data.description)) {
            i18nLang["description"] = data.description;
        }
        if (isString(data.alias)) {
            i18nLang["alias"] = data.alias;
        }
        i18n[lang] = i18nLang;
    }
    return i18n;
};
export default i18next;
